// Shared toolbar control language: flat ink-on-cream plates, square corners,
// Georgia labels — the drafting-table look. Both toolbar rows, and the collage
// toolbar, build their styles from this factory so light/dark stay in sync.

const UI_FONT = "'Georgia', serif";

export const makeToolbarStyles = (darkMode) => {
  const ink = darkMode ? "#e8e2d5" : "#1a1a1a";
  const paper = darkMode ? "#2a251e" : "#fffdf6";
  const bar = darkMode ? "#221d17" : "#f5f0e8";
  const edge = darkMode ? "#4a4238" : "#1a1a1a";
  const controlEdge = darkMode ? "#4a4238" : "#8a8171";
  const accent = darkMode ? "#ffe600" : "#1a1a1a";

  const button = {
    padding: "6px 10px",
    borderRadius: 0,
    border: `1px solid ${controlEdge}`,
    background: paper,
    color: ink,
    cursor: "pointer",
    fontSize: 12,
    fontFamily: UI_FONT,
  };

  const iconButton = {
    ...button,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 34,
    height: 32,
    padding: 0,
  };

  return {
    ink,
    paper,
    edge,
    controlEdge,

    barStyle: {
      display: "flex",
      flexDirection: "column",
      gap: 0,
      padding: 0,
      background: bar,
      color: ink,
      borderBottom: `2px solid ${edge}`,
      position: "sticky",
      top: 0,
      zIndex: 50,
      marginBottom: 12,
    },

    rowStyle: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "8px 12px",
    },

    labelStyle: {
      fontWeight: 700,
      color: ink,
      fontFamily: UI_FONT,
    },

    selectStyle: {
      fontSize: 12,
      fontFamily: UI_FONT,
      padding: "4px 6px",
      borderRadius: 0,
      border: `1px solid ${controlEdge}`,
      background: paper,
      color: ink,
    },

    buttonStyle: button,
    iconButtonStyle: iconButton,

    // Toggled-on state: a lit yellow plate with ink glyph
    activeIconButtonStyle: {
      ...iconButton,
      background: "#ffe600",
      color: "#1a1a1a",
      border: "1px solid #1a1a1a",
    },

    destructiveButtonStyle: {
      ...button,
      color: darkMode ? "#f08c7d" : "#b42318",
      border: `1px solid ${darkMode ? "rgba(240, 140, 125, 0.5)" : "rgba(180, 35, 24, 0.45)"}`,
    },

    destructiveIconButtonStyle: {
      ...iconButton,
      color: darkMode ? "#f08c7d" : "#b42318",
      border: `1px solid ${darkMode ? "rgba(240, 140, 125, 0.5)" : "rgba(180, 35, 24, 0.45)"}`,
    },

    dropdownTriggerStyle: {
      ...button,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },

    panelStyle: {
      position: "absolute",
      top: "100%",
      left: 0,
      zIndex: 100,
      background: paper,
      color: ink,
      border: `2px solid ${edge}`,
      padding: 12,
      display: "flex",
      gap: 8,
      alignItems: "center",
      flexWrap: "wrap",
      boxShadow: "4px 4px 0 rgba(0, 0, 0, 0.2)",
      minWidth: 200,
    },

    // Merge into range inputs so the native slider picks up the brand accent
    sliderStyle: { accentColor: accent },

    colorSwatchStyle: {
      width: 24,
      height: 24,
      padding: 0,
      border: `1px solid ${controlEdge}`,
      cursor: "pointer",
    },
  };
};
